export default {
    url: '/notificationlog',
    template: '<manage-logs-notificationlog></manage-logs-notificationlog>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/manage/logs/notificationlog/index.js